import { Button, CircularProgress } from "@mui/material";

const PayButtonComponent = ({ amountInMinorUnit, ready, enabled, onClick }) => {
  return (
    <>

      <Button
        type="submit"
        variant="contained"
        color="primary"
        id="testPay"
        onClick={onClick}
        disabled={!enabled}
        fullWidth
        sx={{
          height: 48,
          backgroundColor: !ready ? "grey.500" : "#1d3153",
        }}
      >
        {!ready ? (
          <CircularProgress size={24} />
        ) : (
          `Pay £${amountInMinorUnit / 100}`
        )}
      </Button>
    </>
  );
};

export default PayButtonComponent;
